import { Reveal } from "@/lib/motion";

const PARTNERS = [
  {
    id: "alforno",
    logo: "/logo_alforno.jpeg",
    name: "ALFORNO",
    sector: "Boulangerie · Pâtisserie · Glacier",
    text: "ALFORNO fait recours à KORBAN CONSULTING pour son assistance en gestion des ressources humaines & paie, ainsi que pour son assistance fiscale.",
    since: null,
    quote: "Avec eux nous n'avons crainte d'aucun problème",
    quoteBy: "ALFORNO",
  },
  {
    id: "delice-de-paris",
    logo: "/logo_delice_de_paris.jpeg",
    name: "Groupe Délice de Paris",
    sector: "Boulangerie · Pâtisserie & Glacier",
    text: "Le Groupe Délice de Paris nous a choisi pour sa gestion externe complète : comptabilité, fiscalité, RH & paie.",
    since: "Partenaire depuis plus de 5 ans",
  },
];

const pub = (p) => (p ? `${window.location.origin}/api/public/img/${p}` : null);

export default function Partners({ partners }) {
  const list = partners || PARTNERS;
  if (partners && partners.length === 0) return null;
  return (
    <section
      id="partenaires"
      className="border-t border-white/10 bg-korban-navy2/25 py-20 md:py-24"
      data-testid="section-partenaires"
    >
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-korban-gold">
            Ils nous font confiance
          </p>
          <h2 className="mt-4 text-center font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
            Nos partenaires
          </h2>
          <div className="mx-auto mt-5 h-1 w-16 rounded-full bg-korban-gold" />
        </Reveal>

        <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-2">
          {list.map((p, i) => {
            const quoteBy = p.quote_by || p.quoteBy;
            return (
            <Reveal key={p.id} delay={0.08 * (i + 1)}>
              <article
                className="flex h-full flex-col items-center gap-5 rounded-2xl border border-white/10 bg-white/[0.04] p-7 text-center transition-all duration-300 hover:-translate-y-1 hover:border-korban-gold/30 sm:p-8"
                data-testid={`partner-card-${p.id}`}
              >
                <img
                  src={p.logo || pub(p.logo_path) || "/logo_korban_consulting.png"}
                  alt={`${p.name} — ${p.sector || "partenaire"}`}
                  className="h-28 w-28 shrink-0 rounded-2xl object-cover shadow-[0_14px_30px_rgba(0,0,0,0.35)]"
                  loading="lazy"
                />
                <div>
                  <p className="font-display text-xl font-bold text-white">{p.name}</p>
                  {p.sector ? <p className="text-sm font-semibold text-korban-gold">{p.sector}</p> : null}
                  {p.text ? <p className="mt-2.5 text-[0.93rem] leading-relaxed text-slate-300">{p.text}</p> : null}
                  {p.since ? (
                    <p className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-korban-gold/40 bg-korban-gold/10 px-4 py-1.5 text-xs font-bold text-korban-gold">
                      {p.since}
                    </p>
                  ) : null}
                  {p.quote ? (
                    <blockquote
                      className="mt-4 rounded-xl border-l-4 border-korban-gold bg-korban-navy/60 p-4 text-left"
                      data-testid={`partner-quote-${p.id}`}
                    >
                      <p className="font-display text-[1rem] italic leading-relaxed text-slate-200">
                        «&nbsp;{p.quote}&nbsp;»
                      </p>
                      {quoteBy ? (
                        <p className="mt-2 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-korban-gold">
                          — {quoteBy}
                        </p>
                      ) : null}
                    </blockquote>
                  ) : null}
                </div>
              </article>
            </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
